module.exports = __webpack_public_path__ + "img/10.19c4b993.svg";